module.exports = __webpack_public_path__ + "static/laptop-website-4a29513bea961598a12e81e6702ae92c.png";